!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.ti = t());
}(this, function () {
  "use strict";

  return [{
    locale: "ti",
    pluralRuleFunction: function pluralRuleFunction(e, t) {
      return t ? "other" : 0 == e || 1 == e ? "one" : "other";
    },
    fields: {
      year: {
        displayName: "ዓመት",
        relative: {
          0: "ሎሚ ዓመት",
          1: "ንዓመታ",
          "-1": "ዓሚ"
        },
        relativeTime: {
          future: {
            one: "ኣብ {0} ዓ",
            other: "ኣብ {0} ዓ"
          },
          past: {
            one: "ቅድሚ {0} ዓ",
            other: "ቅድሚ {0} ዓ"
          }
        }
      },
      "year-short": {
        displayName: "ዓመት",
        relative: {
          0: "ሎሚ ዓመት",
          1: "ንዓመታ",
          "-1": "ዓሚ"
        },
        relativeTime: {
          future: {
            one: "ኣብ {0} ዓ",
            other: "ኣብ {0} ዓ"
          },
          past: {
            one: "ቅድሚ -{0} ዓ",
            other: "ቅድሚ {0} ዓ"
          }
        }
      },
      month: {
        displayName: "ወርሒ",
        relative: {
          0: "ህሉው ወርሒ",
          1: "ዝመጽእ ወርሒ",
          "-1": "last month"
        },
        relativeTime: {
          future: {
            one: "ኣብ {0} ወርሒ",
            other: "ኣብ {0} ወርሒ"
          },
          past: {
            one: "ቅድሚ {0} ወርሒ",
            other: "ቅድሚ {0} ወርሒ"
          }
        }
      },
      "month-short": {
        displayName: "ወርሒ",
        relative: {
          0: "ህሉው ወርሒ",
          1: "ዝመጽእ ወርሒ",
          "-1": "last month"
        },
        relativeTime: {
          future: {
            one: "ኣብ {0} ወርሒ",
            other: "ኣብ {0} ወርሒ"
          },
          past: {
            one: "ቅድሚ {0} ወርሒ",
            other: "ቅድሚ {0} ወርሒ"
          }
        }
      },
      day: {
        displayName: "መዓልቲ",
        relative: {
          0: "ሎሚ",
          1: "ጽባሕ",
          "-1": "ትማሊ"
        },
        relativeTime: {
          future: {
            one: "ኣብ {0} መዓልቲ",
            other: "ኣብ {0} መዓልቲ"
          },
          past: {
            one: "ቅድሚ {0} መዓልቲ",
            other: "ኣብ {0} መዓልቲ"
          }
        }
      },
      "day-short": {
        displayName: "መዓልቲ",
        relative: {
          0: "ሎሚ",
          1: "ጽባሕ",
          "-1": "ትማሊ"
        },
        relativeTime: {
          future: {
            one: "ኣብ {0} መዓልቲ",
            other: "ኣብ {0} መዓልቲ"
          },
          past: {
            one: "ቅድሚ {0} መዓልቲ",
            other: "ቅድሚ {0} መዓልቲ"
          }
        }
      },
      hour: {
        displayName: "ሰዓት",
        relative: {
          0: "ኣብዚ ሰዓት"
        },
        relativeTime: {
          future: {
            one: "ኣብ {0} ሰዓት",
            other: "ኣብ {0} ሰዓት"
          },
          past: {
            one: "ቅድሚ {0} ሰዓት",
            other: "ቅድሚ {0} ሰዓት"
          }
        }
      },
      "hour-short": {
        displayName: "ሰዓት",
        relative: {
          0: "ኣብዚ ሰዓት"
        },
        relativeTime: {
          future: {
            one: "ኣብ {0} ሰዓት",
            other: "ኣብ {0} ሰዓት"
          },
          past: {
            one: "ቅድሚ {0} ሰዓት",
            other: "ቅድሚ {0} ሰዓት"
          }
        }
      },
      minute: {
        displayName: "ደቒቕ",
        relative: {
          0: "ኣብዚ ደቒቕ"
        },
        relativeTime: {
          future: {
            one: "ኣብ {0} ደቒቕ",
            other: "ኣብ {0} ደቒቕ"
          },
          past: {
            one: "ቅድሚ {0} ደቒቕ",
            other: "ቅድሚ {0} ደቒቕ"
          }
        }
      },
      "minute-short": {
        displayName: "ደቒቕ",
        relative: {
          0: "ኣብዚ ደቒቕ"
        },
        relativeTime: {
          future: {
            one: "ኣብ {0} ደቒቕ",
            other: "ኣብ {0} ደቒቕ"
          },
          past: {
            one: "ቅድሚ {0} ደቒቕ",
            other: "ቅድሚ {0} ደቒቕ"
          }
        }
      },
      second: {
        displayName: "ካልኢት",
        relative: {
          0: "ሕጂ"
        },
        relativeTime: {
          future: {
            one: "ኣብ {0} ካልኢት",
            other: "ኣብ {0} ካልኢት"
          },
          past: {
            one: "ቅድሚ {0} ካልኢት",
            other: "ቅድሚ {0} ካልኢት"
          }
        }
      },
      "second-short": {
        displayName: "ካልኢት",
        relative: {
          0: "ሕጂ"
        },
        relativeTime: {
          future: {
            one: "ኣብ {0} ካልኢት",
            other: "ኣብ {0} ካልኢት"
          },
          past: {
            one: "ቅድሚ {0} ካልኢት",
            other: "ቅድሚ {0} ካልኢት"
          }
        }
      }
    }
  }, {
    locale: "ti-ER",
    parentLocale: "ti"
  }];
});